import { createSlice } from "@reduxjs/toolkit";

const filtersInvoiceSlice = createSlice({
  name: "filterInvoice",
  initialState: {
    filters: {
      sort: {
        column: {
          title: "Datum izdavanja",
          dataIndex: "createdAt",
          key: "createdAt",
          defaultSortOrder: "descend",
        },
        field: "createdAt",
        columnKey: "createdAt",
        order: "descend",
      },
      filters: {},
    },
  },
  reducers: {
    setFiltersInvoice: (state, action) => {
      state.filters = {
        sort: action.payload.sort,
        filters: action.payload.filters,
      };
    },
    resetFiltersInvoice: (state) => {
      state.filters = {
        sort: {
          column: {
            title: "Datum izdavanja",
            dataIndex: "createdAt",
            key: "createdAt",
            defaultSortOrder: "descend",
          },
          field: "createdAt",
          columnKey: "createdAt",
          order: "descend",
        },
        filters: {},
      };
    },
  },
});

export const { setFiltersInvoice, resetFiltersInvoice } =
  filtersInvoiceSlice.actions;
export default filtersInvoiceSlice.reducer;
